import { inject, Injectable, RendererFactory2 } from '@angular/core'
import { analyticsIdsRegExps } from '../regexps/analytics-ids.regexps'

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private readonly rendererFactory = inject(RendererFactory2)
  private readonly renderer = this.rendererFactory.createRenderer(null, null)

  addGoogleAnalytics(id: string): void {
    if (!id || !analyticsIdsRegExps.GOOGLE_ANALYTICS_ID_REGEXP.test(id)) {
      return
    }

    // General script
    const gtagScript = this.renderer.createElement('script')
    gtagScript.async = true
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    this.renderer.appendChild(document.head, gtagScript)

    // Initialization
    const initScript = this.renderer.createElement('script')
    initScript.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}');
    `
    this.renderer.appendChild(document.head, initScript)
  }

  addYandexMetrika(id: string): void {
    if (!id || !analyticsIdsRegExps.YANDEX_METRIKA_ID_REGEXP.test(id)) {
      return
    }

    const yandexScript = this.renderer.createElement('script')
    yandexScript.type = 'text/javascript'
    yandexScript.text = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) { return; }
      }
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
      ym(${id}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true
      });
    `
    this.renderer.appendChild(document.head, yandexScript)

    const noscript = this.renderer.createElement('noscript')
    noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${id}" style="position:absolute; left:-9999px;" alt="" /></div>`
    this.renderer.appendChild(document.head, noscript)
  }

  addFacebookPixel(id: string): void {
    if (!id || !analyticsIdsRegExps.FACEBOOK_PIXEL_ID_REGEXP.test(id)) {
      return
    }

    const fbScript = this.renderer.createElement('script')
    fbScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${id}');
      fbq('track', 'PageView');
    `
    this.renderer.appendChild(document.head, fbScript)

    const noscript = this.renderer.createElement('noscript')
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1" />`
    this.renderer.appendChild(document.head, noscript)
  }

  addVkPixel(id: string): void {
    if (!id || !analyticsIdsRegExps.VK_PIXEL_ID_REGEXP.test(id)) {
      return
    }

    const vkScript = this.renderer.createElement('script')
    vkScript.type = 'text/javascript'
    vkScript.text = `
      !function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,
      t.src="https://vk.com/js/api/openapi.js?169",t.onload=function(){
        VK.Retargeting.Init("${id}");
        VK.Retargeting.Hit();
      },document.head.appendChild(t)}();
    `
    this.renderer.appendChild(document.head, vkScript)

    const noscript = this.renderer.createElement('noscript')
    noscript.innerHTML = `<img src="https://vk.com/rtrg?p=${id}" style="position:fixed; left:-999px;" alt=""/>`
    this.renderer.appendChild(document.head, noscript)
  }

  addTopMailRu(id: string): void {
    if (!id || !analyticsIdsRegExps.MAIL_RU_COUNTER_ID_REGEXP.test(id)) {
      return
    }

    const topMailScript = this.renderer.createElement('script')
    topMailScript.type = 'text/javascript'
    topMailScript.text = `
      var _tmr = window._tmr || (window._tmr = []);
      _tmr.push({id: "${id}", type: "pageView", start: (new Date()).getTime()});
      (function (d, w, id) {
        if (d.getElementById(id)) return;
        var ts = d.createElement("script");
        ts.type = "text/javascript";
        ts.async = true;
        ts.id = id;
        ts.src = "https://top-fwz1.mail.ru/js/code.js";
        var f = function () {
          var s = d.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(ts, s);
        };
        if (w.opera == "[object Opera]") {
          d.addEventListener("DOMContentLoaded", f, false);
        } else { f(); }
      })(document, window, "tmr-code");
    `
    this.renderer.appendChild(document.head, topMailScript)

    const noscript = this.renderer.createElement('noscript')
    noscript.innerHTML = `<div><img src="https://top-fwz1.mail.ru/counter?id=${id};js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div>`
    this.renderer.appendChild(document.head, noscript)
  }
}
